import React, { Component } from "react";

import { Tooltip, Icon } from "antd";

const TCHelpTooltip = ({ text, trigger = "hover", type = "tooltip" }) => (
  <Tooltip placement="right" title={text} trigger={trigger}>
    <Icon type="info-circle-o" style={{ marginLeft: 5 }} />
  </Tooltip>
);
export default TCHelpTooltip;
